import React, { useState, useEffect } from 'react';
import { Modal, Button, CloseButton } from 'react-bootstrap';
import parse from 'html-react-parser';

const GiftCardDetailModal = (props) => {
	return (
		<>
			<Modal
				show={props.show}
				onHide={props.close}
				size='lg'
				centered>
				<Modal.Header>
					<Modal.Title style={{ fontSize: '16px', fontWeight: 600 }}>
						Gift Card Details
					</Modal.Title>
					<CloseButton
						onClick={props.close}
						variant='black'
					/>
				</Modal.Header>
				<Modal.Body
					className='dashboard__transactionsModal'
					style={{ position: 'relative', minHeight: '85px' }}>
					<div className='dashboard__transactionsModalProfile'>
						<div className='dashboard__transactionsModalDetails'>
							<div className='dashboard__transactionsModalBottom'>
								<div className='gc_modal_box'>
									<div className='gc_title'>
										<h5>
											Title:{' '}
											<span>{props?.code?.title}</span>
										</h5>
									</div>
									<div className='gc_amount'>
										<h5>Amount:</h5>
										<span className='gc_amount_box'>
											{Array.isArray(
												props?.code?.denominations,
											) &&
												props?.code?.denominations.map(
													(ele, i) => {
														return (
															<span
																key={i}
																className='gc_amount_single'>
																<span
																	className=''
																	title={
																		ele.fix_value
																	}>
																	<span>
																		{
																			props.currencySymbol
																		}
																	</span>
																	{
																		ele.fix_value
																	}
																</span>
															</span>
														);
													},
												)}
										</span>
									</div>
									<div className=''>
										<h5>Terms and Conditions:</h5>
										<span>{parse(props?.code?.tnc)}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={props.close}>Close</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default GiftCardDetailModal;

